import { useEffect, useState } from "react";
import { watchMediaQuery } from "../utils/mediaQuery";

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    return watchMediaQuery(query, setMatches);
  }, [query]);

  return matches;
};
